import { render, staticRenderFns } from "./BotAlerts.vue?vue&type=template&id=599540f1&"
import script from "./BotAlerts.vue?vue&type=script&lang=ts&"
export * from "./BotAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports